var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceCookiesDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9993 60C13.4577 60 0 46.5477 0 30.0131C0 13.4637 13.4577 0 29.9993 0C46.5419 0 60 13.4637 60 30.0131C60 46.5477 46.5419 60 29.9993 60ZM14.9578 9C12.0383 11.1638 9.5757 13.9538 7.79539 17.1257C5.6396 20.9667 4.5 25.3388 4.5 29.7687C4.5 43.9567 15.9388 55.5 29.9988 55.5C44.0602 55.5 55.5 43.957 55.5 29.7687C55.5 25.3378 54.3614 20.9662 52.2068 17.1269C50.4272 13.9565 47.9653 11.1679 45.0461 9.00531C44.6919 13.4363 38.2101 16.8536 29.9988 16.8536C21.7882 16.8536 15.3077 13.4336 14.9578 9ZM29.9977 3C27.15 3 24.4477 3.6232 22.3884 4.75479C20.5798 5.74874 19.5 7.05724 19.5 8.25578C19.5 9.45217 20.5796 10.7583 22.3875 11.7492C24.4463 12.8784 27.1489 13.5 29.9975 13.5C32.8461 13.5 35.5498 12.8784 37.6098 11.7492C39.4195 10.7574 40.5 9.45163 40.5 8.25578C40.5 7.05751 39.4195 5.74874 37.6098 4.75479C35.5494 3.6232 32.8459 3 29.9977 3Z",
    fill: "#181B25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceCookiesDefaultIcon);
export default __webpack_public_path__ + "static/media/experience-cookies-default-icon.1f0cac48b0853c2082aac684bc70d665.svg";
export { ForwardRef as ReactComponent };